import { createElement, memo, useState, useEffect, useCallback, useRef, useMemo } from '@max/max';
import { useMonitorEngineContext } from "@nibfe/mcp-monitor-sdk";
import SlideModal from '@max/leez-slide-modal';
import View from '@hfe/max-view';
import ScrollView from '@hfe/max-scrollview';
import LImage from '@max/leez-image';
import { rpx2px } from '@hfe/max-universal-unit-tool';
import { SystemType, getSystemType } from '@nibfe/mkt-env-api';
import cityListData from '@/data/city_list';
// import { screenHeight, statusBarHeight } from '../until';
const isMRN = false;
const isWeb = true;
import './index.scss';
import TextInput from '@hfe/max-textinput';
import Text from '@hfe/max-text';
function CitySelectionModal(p) {
    const ctx = useMonitorEngineContext();
    const scrollViewRef = useRef(null);
    const [visible, setVisible] = useState(p.visible);
    const [searchText, setSearchText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const reachEnd = useCallback(() => { }, []);
    // const { cityList: allCityList=[] } = p;
    const { selectCityIds = [] } = p;
    let allCityList = cityListData;
    if (selectCityIds.length) {
        allCityList = allCityList.filter(city => {
            return !selectCityIds.includes(city.cityId);
        });
    }
    ;
    useEffect(() => {
        setVisible(p.visible);
    }, [p.visible]);
    const handleSelectCity = (city) => {
        p.onCityChange(city);
        p.onClose();
    };
    const cityList = useMemo(() => {
        if (!searchText) {
            return allCityList;
        }
        const renderCityList = allCityList.filter(city => city.cityName.includes(searchText));
        return renderCityList;
    }, [searchText]);
    const systemType = getSystemType();
    const isIOS = systemType === SystemType.ios;
    return <>
      <SlideModal visible={visible} showHeader={false} showCloseBtn={false} maskClosable={true} addBottomSpace={false} 
    // modalMaxHeight={100}
    contentStyle={{
        margin: 0,
        paddingLeft: 0,
        paddingRight: 0,
        padding: 0
    }} onClosePress={p.onClose}>
        <View className="city-selection-header-wrap">
          <LImage className="city-selection-header-image" source={{
        uri: 'https://img.meituan.net/makerjiulv/4b501d85fad921212232072d0a6fe14916826.png'
    }} width={rpx2px(750)} height={rpx2px(1312)} borderRadius={0}>
            <LImage className="city-selection-header-title-image" source={{
        uri: 'https://img.meituan.net/makerjiulv/5eed2b6147c9f08abf6b2646b181f1bd7520.png'
    }} style={{
        width: '560rpx',
        height: '45rpx'
    }} borderRadius={0}/>
            <Text className="header-tips">下单成功后可解锁抽免单资格</Text>
            <View className="city-selection-header-append-block"/>
          </LImage>
          <LImage source={{
        uri: 'https://img.meituan.net/makerjiulv/e18359a5f095559a508718be72c2b0301324.png'
    }} style={{
        width: '44rpx',
        height: '44rpx',
        position: 'absolute',
        right: '20rpx',
        top: '15rpx'
    }} onPress={p.onClose}/>
        </View>
        <View className="city-selection-main">
          <View className="city-selection-input-wrap">
            <LImage className="city-selection-input-icon" source={{
        uri: 'https://p0.meituan.net/travelcube/20cedfd450e06a9260d775e1a634bdac2015.png'
    }} style={{
        width: '28rpx',
        height: '28rpx'
    }}/>
            <View style={{
        flex: 1
    }}>
              <TextInput className="city-selection-input" placeholderColor="#999999" numberOfLines={1} placeholder="搜索城市" 
    // autoFocus
    onChangeText={text => {
        setSearchText(text.trim());
    }}/>
            </View>
          </View>
          
          <ScrollView className="city-selection-container" showsVerticalScrollIndicator={false} refreshType={'none'} ref={scrollViewRef} style={{
        height: isIOS ? '1000rpx' : '700rpx'
    }} disableScroll={false} onEndReached={reachEnd} onEndReachedThreshold={100}>
            <View x-if={cityList === null || cityList === void 0 ? void 0 : cityList.length}>
              {cityList.map((city, index) => {
        return <View className="city-selection-item" key={city.cityId} onClick={() => handleSelectCity(city)}>
                    <Text className="city-selection-item-text">{city.cityName}</Text>
                  </View>;
    })}
            </View>
            <View x-else className="city-selection-not-found" style={{
        zIndex: 1,
        height: '100%'
    }}>
              <LImage className="city-selection-not-found-image" source={{
        uri: 'https://p0.meituan.net/ingee/1341ccc13d77c96bd342ddf3edd0834550429.png'
    }} width={rpx2px(300)} height={rpx2px(326)}/>
              <Text className="city-selection-not-found-text-normal">未找到可点亮的城市</Text>
            </View>
          </ScrollView>
        </View>
        
      </SlideModal>
    </>;
}
export default memo(CitySelectionModal);
